import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { shortenText } from "utils";
import DisplayBox from "components/DisplayBox";
import RenderMemberGroupList from "components/DisplayBox/Renderers/RenderMemberGroupList";
import { Tag, TAG_SIZE } from "components/Tags";
import { MissionAdvancedOptions } from "components/Missions";
import { margins } from "style";
import { useLinks } from "hooks";

/**
 * MissionsHighlights
 *
 * @param {String}   loading
 * @param {Array}    data
 * @param {String}   emptyMsgId
 */
const MissionsHighlights = ({ loading, data, emptyMsgId, ...props }) => {
  const links = useLinks();
  const isEmpty = !loading && data?.length === 0;

  return (
    <DisplayBox
      title={<FormattedMessage id="Missions.MissionsHighlight.Title" />}
      marginSize={margins.normal}
      loading={loading}
      rowGap={0}
      numColumns={1}
      data={data}
      isEmpty={isEmpty}
      emptyMsg={<FormattedMessage id={`${emptyMsgId || "Missions.MissionsHighlight.EmptyMsg"}`} />}
      itemRenderer={(item, index, loading) => (
        <RenderMemberGroupList
          key={item.id || item.uuid}
          title={item.name}
          subtitle={
            item?.isDefault ? (
              <Tag size={TAG_SIZE.small}>
                <FormattedMessage id="Global.Default" />
              </Tag>
            ) : (
              shortenText(item.description, 70)
            )
          }
          linkTo={links.mission_edit(item.uuid)}
          rightContent={<MissionAdvancedOptions data={item} loading={loading} />}
          loading={loading}
          index={index}
        />
      )}
      {...props}
    />
  );
};

MissionsHighlights.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  emptyMsgId: PropTypes.string,
};

export default MissionsHighlights;
